export default __webpack_public_path__ + "static/media/retire-campaign-bg.04a6faff.png";